module.exports = __webpack_public_path__ + "static/media/webdesign-services-img65.3772d8e6.jpg";